<template>
  <div
    :id="`tab-panel-${uid}`"
    class="tab-pane"
    :class="{ active: isActive, show: isActive }"
    role="tabpanel"
    :aria-hidden="isActive ? 'false' : 'true'"
    :aria-labelledby="`tab-button-${uid}`"
  >
    <template v-if="shouldRender">
      <OverlayScrollbars
        v-if="scrollable"
        :style="'height: ' + scrollHeight + ';'"
      >
        <slot />
      </OverlayScrollbars>
      <slot v-else />
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsTab',

  inject: {
    rsTabsInstance: { default: null },
  },

  props: {
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
    changedStatus: {
      type: Object,
      default: () => ({}),
    },
    scrollable: {
      type: Boolean,
      default: false,
    },
    scrollHeight: {
      type: String,
      default: '400px',
    },
    title: String,
    content: String,
    badgeNumber: Number,
    badgeVariant: String,
  },

  emits: ['click'],

  computed: {
    uid(): number {
      return this.$.uid;
    },
    isActive(): boolean {
      const tabs = (this as any).rsTabsInstance;
      if (!tabs) return true;
      return tabs.activeRsTab === tabs.registeredTabs.indexOf(this);
    },
    shouldRender(): boolean {
      const tabs = (this as any).rsTabsInstance;
      if (!tabs || !tabs.lazy) return true;
      return this.isActive;
    },
  },

  mounted() {
    const tabs = (this as any).rsTabsInstance;
    if (tabs) tabs.registerRsTab(this);
  },

  beforeUnmount() {
    const tabs = (this as any).rsTabsInstance;
    if (tabs) tabs.unregisterRsTab(this);
  },

  methods: {
    tabClicked(): void {
      this.$emit('click', [this.title, this.changedStatus]);
    },
  },
});
</script>
